export default {
  title: "Whoops!",
  button: "Go Back",
  description:
    "Parece que não conseguimos encontrar a página que você estava procurando",
};
